import type { DocPageContent } from '../types';

/**
 * "Chat starters" — Dashboard section (ADR-0074).
 * Reconciled from apps/web `features/engagement/suggestions` — the Suggestions
 * tab of `/engagement` (ADR-0538 merged `/starters` into it) — and the
 * `chatstarters.*` catalog. Starters belong to a widget DESIGN rather than to
 * the workspace, which is the one thing about this surface that surprises
 * people, so it is the first thing the page says.
 */
export const DASHBOARD_STARTERS_PAGE: DocPageContent = {
  slug: 'dashboard/starters',
  titleKey: 'docs.dashboard.starters.title',
  descriptionKey: 'docs.dashboard.starters.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.starters.lead' },

    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.dashboard.starters.design.title',
      textKey: 'docs.dashboard.starters.design.body',
      links: {
        design: {
          target: { docSlug: 'dashboard/design' },
          labelKey: 'docs.dashboard.starters.design.link',
        },
      },
    },

    {
      kind: 'heading',
      level: 2,
      id: 'writing',
      textKey: 'docs.dashboard.starters.writing.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.starters.writing.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.starters.writing.item.parts',
        'docs.dashboard.starters.writing.item.limit',
        'docs.dashboard.starters.writing.item.order',
        'docs.dashboard.starters.writing.item.languages',
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'suggestions',
      textKey: 'docs.dashboard.starters.suggest.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.starters.suggest.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.starters.suggest.item.conversations',
        'docs.dashboard.starters.suggest.item.capabilities',
        'docs.dashboard.starters.suggest.item.gaps',
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'publishing',
      textKey: 'docs.dashboard.starters.publish.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.starters.publish.body' },
    {
      kind: 'callout',
      tone: 'tip',
      titleKey: 'docs.dashboard.starters.publish.preview.title',
      textKey: 'docs.dashboard.starters.publish.preview.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.starters.next.design.title',
          textKey: 'docs.dashboard.starters.next.design.text',
          to: { docSlug: 'dashboard/design' },
        },
        {
          titleKey: 'docs.dashboard.starters.next.proactive.title',
          textKey: 'docs.dashboard.starters.next.proactive.text',
          to: { docSlug: 'dashboard/proactive' },
        },
      ],
    },
  ],
};
